import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../icon";
export default function RotateCW(props) {
    return (_jsxs(Icon, { ...props, children: [_jsx("path", { d: "M23 3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h5V4a1 1 0 0 1 1-1Z" }), _jsx("path", { d: "M13.127 4.081a8 8 0 1 0 6.42 10.586 1 1 0 0 1 1.886.666 10 10 0 1 1-2.367-10.41l4.62 4.349a1 1 0 1 1-1.372 1.456l-4.63-4.36a8 8 0 0 0-4.557-2.287Z" })] }));
}
